import usePageTitle from "@/hooks/usePageTitle";

const Home: React.FC = () => {
  usePageTitle("صفحه اصلی");

  return <div>Home Page</div>;
};

export default Home;
